import { IPriceType, IQuoteAvailability } from '~/purchase/types';
import { TranslationKeys } from '~/common/types';

export const QUOTE_AVAILABILITY_TRANSLATIONS: Record<
  IQuoteAvailability,
  keyof TranslationKeys
> = {
  IN_STOCK: 'app.purchase.quote_search_page.product.availability.in_stock',
  IN_PARENT_STOCK:
    'app.purchase.quote_search_page.product.availability.in_parent_stock',
  ORDERABLE: 'app.purchase.quote_search_page.product.availability.on_order',
  NOT_ORDERABLE: 'app.common.status.not_orderable',
  UNAVAILABLE:
    'app.purchase.quote_search_page.product.availability.unavailable',
};

const BASE_PRICE_TYPE_LOOKUP: {
  [key in IPriceType]: keyof TranslationKeys;
} = {
  TAX_EXCLUDED: 'app.common.price.tax_excluded',
  TAX_INCLUDED: 'app.common.price.tax_included',
};

const UNIT_PRICE_TYPE_LOOKUP: {
  [key in IPriceType]: keyof TranslationKeys;
} = {
  TAX_EXCLUDED: 'app.common.unit_price_without_tax',
  TAX_INCLUDED: 'app.common.unit_price_with_tax',
};

export function getQuoteServicePriceTypeTranslation(
  priceType: IPriceType,
  style: 'basic' | 'unit' = 'basic',
): keyof TranslationKeys {
  return style === 'basic'
    ? BASE_PRICE_TYPE_LOOKUP[priceType]
    : UNIT_PRICE_TYPE_LOOKUP[priceType];
}
